export const PAGE_SIZE_OPTIONS = ['10', '20', '50'];

const STATUS_STYLES = {
  active:
    'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-200',
  stable:
    'border-slate-200 bg-slate-100 text-slate-700 dark:border-slate-500/20 dark:bg-slate-500/10 dark:text-slate-200',
  ready:
    'border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-200',
};

const getProjectStatus = (item, rolloutCount) => {
  const rawStatus =
    item?.status ||
    item?.project?.status ||
    item?.version?.status ||
    (rolloutCount > 15 ? 'Active' : rolloutCount > 0 ? 'Stable' : 'Ready');

  const normalized = String(rawStatus).toLowerCase();

  if (normalized.includes('active')) {
    return { label: rawStatus, className: STATUS_STYLES.active };
  }

  if (normalized.includes('stable')) {
    return { label: rawStatus, className: STATUS_STYLES.stable };
  }

  return {
    label:
      typeof rawStatus === 'string' && rawStatus.length > 0
        ? rawStatus
        : 'Ready',
    className: STATUS_STYLES.ready,
  };
};

export const normalizeProject = (item, index) => {
  const rolloutCount = Number(item?.rolloutCount ?? item?.rolloutsCount ?? 0);
  const status = getProjectStatus(item, rolloutCount);
  const projectName = item?.project?.name ?? item?.name ?? 'Untitled Project';
  const versionName =
    item?.version?.name ?? item?.versionName ?? item?.latestVersion ?? 'N/A';

  return {
    key:
      item?.id ??
      `${item?.project?.id ?? 'project'}-${item?.version?.id ?? 'version'}-${index}`,
    projectId: item?.project?.id ?? item?.projectId ?? null,
    versionId: item?.version?.id ?? item?.versionId ?? null,
    projectName,
    versionName,
    rolloutCount,
    description:
      item?.project?.description ??
      item?.description ??
      `Deployment workspace for ${projectName}.`,
    status,
  };
};

export const getCreateRolloutState = (project) => ({
  project: {
    value: String(project.projectId),
    label: project.projectName,
  },
  version: {
    value: String(project.versionId),
    label: project.versionName,
  },
});

export const buildRolloutListLocation = (project) => {
  const projectId = project?.projectId ?? project?.project?.id ?? null;
  const versionId = project?.versionId ?? project?.version?.id ?? null;
  const projectName = String(
    project?.projectName ?? project?.project?.name ?? ''
  ).trim();
  const versionName = String(
    project?.versionName ?? project?.version?.name ?? ''
  ).trim();

  if (!projectId || !versionId) {
    return null;
  }

  const state = {};
  const searchParams = new URLSearchParams();

  if (projectName) {
    state.projectName = projectName;
    searchParams.set('projectName', projectName);
  }

  if (versionName) {
    state.versionName = versionName;
    searchParams.set('versionName', versionName);
  }

  const search = searchParams.toString();

  return {
    pathname: `/rolloutList/${projectId}/${versionId}${search ? `?${search}` : ''}`,
    state,
  };
};
